/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import CreateInstantFeedback from 'domain/people/feedback/instantFeedback/createupdate/Create';

export const OLD_INSTANT_FEEDBACK_PATH = '/instant-feedbacks';
export const INSTANT_FEEDBACK_PATH = '/instant-feedback';

const useInstantFeedbackRoute = () => {
  return createRoute({ listRoute: INSTANT_FEEDBACK_PATH });
};

const InstantFeedbackRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { createRoute: createInstantFeedbackRoute } = useInstantFeedbackRoute();

  return (
    <ProtectedRouter basePath={INSTANT_FEEDBACK_PATH}>
      <Routes>
        <Route path={createInstantFeedbackRoute} element={<CreateInstantFeedback />} />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

InstantFeedbackRouter.getRouterPath = () => `${INSTANT_FEEDBACK_PATH}/*`;

export default InstantFeedbackRouter;
